export const MARKETING_CAMPAIGN_CONTENT = 'marketing_campaign_content';

export enum DisplayMode {
  INFO_POP_IN = 'info-popin',
  DEFAULT = 'default',
  FOOTER = 'footer',
  RIGHT_SIDEBAR = 'right-sidebar'
}

export interface MarketingCampaignContent {
  title: string;
  iconURL: string;
  marketingItems: Map<string, MarketingItem[]>;
}

export interface MarketingItem {
  title: string;
  iconURL?: string;
  text?: string;
}
